module.exports = __webpack_public_path__ + "static/media/f5d48ca2.jpg";